"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateSourceTypeToTooltip = exports.translateSourceTypeToIconName = void 0;
var _mergeInputField = require("../mergeInputField.data");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var personDataType = _mergeInputField.dataTypes.personDataType,
  globalDataType = _mergeInputField.dataTypes.globalDataType,
  libraryBlockType = _mergeInputField.dataTypes.libraryBlockType,
  promotionType = _mergeInputField.dataTypes.promotionType,
  promotionFieldType = _mergeInputField.dataTypes.promotionFieldType,
  lookupType = _mergeInputField.dataTypes.lookupType,
  lookupFieldType = _mergeInputField.dataTypes.lookupFieldType;
var translateSourceTypeToIconName = function translateSourceTypeToIconName(sourceType) {
  var _iconNameMap;
  var iconNameMap = (_iconNameMap = {}, _defineProperty(_iconNameMap, personDataType, 'user'), _defineProperty(_iconNameMap, globalDataType, 'globe'), _defineProperty(_iconNameMap, libraryBlockType, 'code'), _defineProperty(_iconNameMap, promotionType, 'compass'), _defineProperty(_iconNameMap, promotionFieldType, 'compass'), _defineProperty(_iconNameMap, lookupType, 'search'), _defineProperty(_iconNameMap, lookupFieldType, 'search'), _iconNameMap);
  return iconNameMap[sourceType];
};
exports.translateSourceTypeToIconName = translateSourceTypeToIconName;
var translateSourceTypeToTooltip = function translateSourceTypeToTooltip(_ref) {
  var _iconTooltipMap;
  var sourceType = _ref.sourceType,
    locale = _ref.locale;
  var iconTooltipMap = (_iconTooltipMap = {}, _defineProperty(_iconTooltipMap, personDataType, locale.personData), _defineProperty(_iconTooltipMap, globalDataType, locale.globalData), _defineProperty(_iconTooltipMap, libraryBlockType, locale.libraryBlock), _defineProperty(_iconTooltipMap, promotionType, locale.promotionField), _defineProperty(_iconTooltipMap, promotionFieldType, locale.promotionField), _defineProperty(_iconTooltipMap, lookupType, locale.lookupField), _defineProperty(_iconTooltipMap, lookupFieldType, locale.lookupField), _iconTooltipMap);
  return iconTooltipMap[sourceType];
};
exports.translateSourceTypeToTooltip = translateSourceTypeToTooltip;